module.exports = __webpack_public_path__ + "static/media/CardStatementNew.89735fae.svg";